<template>
  <div class="col q-px-xs-sm q-px-sm-lg q-py-md" style="overflow-y: auto">
    <slot></slot>
  </div>
</template>
